require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-basics-of-optionals-in-swift.json") })
        }
      }, "path---blog-the-basics-of-optionals-in-swift");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-basics-of-optionals-in-swift!./.cache/json/blog-the-basics-of-optionals-in-swift.json
// module id = 1091
// module chunks = 231608221292675